import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './ga';
import App from './App';
import { Analytics } from '@vercel/analytics/react';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <>
    <App />
    <Analytics />
  </>
);
